import {
  SHTableBody,
  SHTableCell,
  SHTableRow,
} from "@components/design-systems";
import { FeePortfolioDetailDTO } from "@models/platform-analysis/entities/portfolioDetails";
import { FeeSubProductDTO } from "@models/platform-analysis/entities/steps/fee";
import { FeeCalculatorPortfolioLevel } from "@models/platform-analysis/enums/fee/portfolioLevel";
import { getStringFamilyMemberAccounts } from "@pages/platform-analysis-v2/_id/utils";
import { memo, useMemo } from "react";
import { getAnalysisSummaryPortfolioDetailTableRows } from "../../utils";
import { AnalysisSummaryPortfolioDetailsTableWrapper } from "../wrapper";

interface AnalysisSummaryPortfolioDetailsTableProps {
  portfolioDetails?: FeePortfolioDetailDTO | null;
  selectedSubProducts?: FeeSubProductDTO[];
  hiddenIds?: string[];
  portfolioLevel?: FeeCalculatorPortfolioLevel;
  showHoldingsNumber?: boolean;
}

export const AnalysisSummaryPortfolioDetailsTable = memo(
  ({
    portfolioDetails,
    selectedSubProducts,
    hiddenIds,
    portfolioLevel,
    showHoldingsNumber,
  }: AnalysisSummaryPortfolioDetailsTableProps) => {
    const detailRows = useMemo(
      () =>
        getAnalysisSummaryPortfolioDetailTableRows({
          data: portfolioDetails,
          selectedSubProducts,
          hiddenSubProductIds: hiddenIds,
          portfolioLevel,
          showHoldingsNumber,
        }),
      [
        portfolioDetails,
        selectedSubProducts,
        hiddenIds,
        portfolioLevel,
        showHoldingsNumber,
      ],
    );

    return (
      <AnalysisSummaryPortfolioDetailsTableWrapper>
        <SHTableBody>
          {portfolioDetails?.familyMembers?.map((familyMember, index) => {
            return (
              <SHTableRow key={index}>
                <SHTableCell>{familyMember.name}</SHTableCell>
                <SHTableCell>
                  {getStringFamilyMemberAccounts(
                    familyMember.familyMemberAccounts,
                  )}
                </SHTableCell>
              </SHTableRow>
            );
          })}

          {detailRows?.map((row, index) => (
            <SHTableRow key={index}>
              <SHTableCell>{row.label}</SHTableCell>
              <SHTableCell>{row.value}</SHTableCell>
            </SHTableRow>
          ))}
        </SHTableBody>
      </AnalysisSummaryPortfolioDetailsTableWrapper>
    );
  },
);
